import styled from 'styled-components';
import { TrimSelectStyled } from '../TrimSelectStyled';
import { rem } from 'polished';

export const TrimSelectStyledDS = styled(TrimSelectStyled)`
    padding: 0 0 ${rem(20)} 0;

    .trim {
        border: solid 1px ${({ theme }) => theme.colors.grey16};
        border-radius: ${rem(8)};
        background: ${({ theme }) => theme.colors.white};

        &.isSelected,
        &:hover {
            background: ${({ theme }) => theme.colors.grey4};
            border: 1px solid ${({ theme }) => theme.colors.secondary};
            .inner {
                border-color: ${({ theme }) => theme.colors.secondary};
            }
        }

        .inner {
            border-radius: ${rem(6)};
        }
    }

    .trimTitle {
        font-size: ${({ theme }) => theme.fontSizes.h5};
        color: ${({ theme }) => theme.colors.black};

        .icon {
            border-color: ${({ theme }) => theme.colors.black};

            .selected {
                width: ${rem(14)};
                height: ${rem(14)};
                top: ${rem(4)};
                left: ${rem(4)};
            }
        }
    }

    .trimContent {
        font-size: ${({ theme }) => theme.fontSizes.h6};

        &.description {
            color: ${({ theme }) => theme.colors.grey29};
        }
    }

    .isSelected {
        border-color: ${({ theme }) => theme.colors.black1} !important;
        background-color: ${({ theme }) => theme.colors.accordionSecondaryBg};
    }
`;
